var keyMirror = require('keymirror');

module.exports = keyMirror({
    PUSH_NOTIFICATION: null
});